module.exports = __webpack_public_path__ + "img/img-dff7e9.png";